import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { PublicationSource } from '../../components/search/publication-source';
import { SearchMode } from '../../components/search/search-mode';

const sortDefault = {
  field: 'publication_date',
  dir: 'desc',
};

@Injectable({ providedIn: 'root' })
export class SearchService {
  protected subject = new ReplaySubject<object>(0);
  protected limit = 25;
  protected offset = 0;
  protected text = '';
  private name = '';
  protected sortBy: object = sortDefault;
  protected filters!: object;
  protected perimeter!: Array<string>;

  protected searchModeMap = new Map<PublicationSource, SearchMode>();

  searchValue?: { id: number; name: string } | string;

  public currentPage = 1;
  public nbPages = 1;

  constructor() {
    this.initSearchModeMap();
  }

  /** Map storing the selected search mode every publication source */
  get SearchModeMap() {
    return this.searchModeMap;
  }

  reset() {
    this.limit = 25;
    this.sortBy = sortDefault;
    this.offset = 0;
  }

  sentText(text: string) {
    this.text = text;
    this.offset = this.limit * (this.currentPage - 1);
    this.sendSearch();
  }

  resetText() {
    this.sortBy = sortDefault;
    this.offset = 0;
    this.text = '';
    this.searchValue = undefined;
    this.sendSearch();
  }

  sentName(name: string) {
    this.name = name;
    this.offset = 0;
    this.sendSearch();
  }

  resetName() {
    this.name = '';
  }

  sentLimit(limit: number) {
    this.limit = limit;
    this.currentPage = 1;
    this.offset = 0;
    this.sendSearch();
  }

  sentSort(sortBy: object) {
    this.sortBy = sortBy;
    this.offset = 0;
    this.currentPage = 1;
    this.sendSearch();
  }

  sentPageIndex(pageIndex: number) {
    this.currentPage = pageIndex;
    this.offset = this.limit * (pageIndex - 1);
    this.sendSearch();
  }

  sentFilter(filters: object) {
    this.filters = filters;
    this.offset = 0;
    this.currentPage = 1;
    this.sendSearch();
  }

  sendPerimeter(perimeter: Array<string>) {
    this.perimeter = perimeter;
  }

  sendSearch() {
    this.subject.next({
      name: this.name,
      text: this.text,
      limit: this.limit,
      offset: this.offset,
      filters: this.filters,
      perimeter: this.perimeter,
      sortBy: this.sortBy,
    });
  }

  getSearch(): Observable<object> {
    return this.subject;
  }

  /** Init of every publication source searchMode to text */
  initSearchModeMap() {
    this.searchModeMap.set(PublicationSource.ARTICLES, SearchMode.TEXT);
    this.searchModeMap.set(PublicationSource.ADMIN_DOCS, SearchMode.TEXT);
    this.searchModeMap.set(PublicationSource.OTHERS, SearchMode.TEXT);
  }

  resetSearchModeMap() {
    this.initSearchModeMap();
  }

  resetSearchServiceMaps() {
    this.resetSearchModeMap();
    this.resetName();
  }
}
